/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from '../Member/components/LandingPage/LandingPage';
import PageNotFound from 'src/Components/PageNotFound';

export default function LandingPageRoute() {
  const queryParams = new URLSearchParams(window.location.search);
  const route = queryParams.get('page');
  if (route) {
    return <Navigate to={`/member/page/${route}`} />;
  }
  return (
    <Routes>
      <Route exact path="/" element={<LandingPage />} />
      {/*<Route exact path="/*" component={( property ) => {
        const pathname = property.location.pathname;
        return <PageNotFound pathname={pathname} validateUrl={true} />;
      }} /> */}
    </Routes>
  );
}
